import { CheckIcon } from '@heroicons/react/24/outline';
import { JSX } from 'react/jsx-runtime';

import { useStepper } from '@/hooks/useStepper';

import { Icon } from '../Icon';

const StepProgress = () => {
    const { currentStep, steps } = useStepper();

    const renderSteps = () => {
        const stepsElement: JSX.Element[] = [];
        steps.map((step, i) => {
            const index = i + 1;
            stepsElement.push(
                <div key={i} className="tw-w-full tw-items-center">
                    <div className="tw-flex tw-items-center tw-w-full">
                        {i < steps.length && (
                            <div
                                className={`tw-h-[1px] tw-flex-grow ${
                                    index <= currentStep
                                        ? 'tw-bg-primary'
                                        : 'tw-bg-gray-400'
                                }`}
                            ></div>
                        )}
                        <div>
                            <div
                                className={`tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-border tw-rounded-[6px] ${
                                    index < currentStep
                                        ? 'tw-bg-primary'
                                        : index == currentStep
                                            ? 'tw-border-solid tw-border-primary'
                                            : 'tw-border-solid tw-border-gray-400'
                                }`}
                            >
                                {index > currentStep || index == currentStep ? (
                                    <span className="tw-text-gray-400">
                                        {index}
                                    </span>
                                ) : null}
                                {index < currentStep ? (
                                    <Icon
                                        icon={CheckIcon}
                                        size="lg"
                                        variant="light"
                                        colorScheme="lighter"
                                    />
                                ) : null}
                            </div>
                        </div>
                        <div
                            className={`tw-h-[1px] tw-flex-grow  tw-w-1 ${
                                index < currentStep
                                    ? 'tw-bg-primary'
                                    : 'tw-bg-gray-400'
                            }`}
                        ></div>
                    </div>
                    <div className="tw-pt-3 tw-flex tw-items-center tw-w-full">
                        {i < steps.length && (
                            <div className="tw-flex-grow"></div>
                        )}
                        <div className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-text-center tw-w-fit">
                            {step}
                        </div>
                        <div className=" tw-flex-grow"></div>
                    </div>
                </div>,
            );
        });
        return stepsElement;
    };

    return <div className="tw-flex tw-w-full">{renderSteps()}</div>;
};
export default StepProgress;
